import type { IncomingHttpHeaders } from 'node:http';
import { InternalServerError } from 'restify-errors';
import { uniq } from 'lodash';
import type { Segment } from '@fixter/i18n';
import { getApolloClient } from '$apollo/util';
import type { QueryGetProductGroups, QueryGetProductGroupsVariables } from '../gql';
import { QUERY_GET_PRODUCT_GROUPS } from '../gql';

export const expandProductGroupSkus = (skus: string[], productGroups: Map<string, string[]>): string[] =>
  uniq(skus.flatMap((sku) => sku.split(';').flatMap((s) => productGroups.get(s) || s)));

export const getGroupProductSkus = async (
  segment: Segment,
  headers: IncomingHttpHeaders
): Promise<Map<string, string[]>> => {
  const info = { segment };
  try {
    const apolloClient = getApolloClient();
    const { data } = await apolloClient.query<QueryGetProductGroups, QueryGetProductGroupsVariables>({
      query: QUERY_GET_PRODUCT_GROUPS,
      variables: { segment },
      context: { headers },
    });

    const groupProducts = data?.getProductGroups.reduce(
      (gp, { groupSlug, productSkuList }) => gp.set(groupSlug, productSkuList),
      new Map<string, string[]>()
    );

    return groupProducts;
  } catch (error) {
    throw new InternalServerError({ info, error }, 'Failed to fetch repairs catalog data');
  }
};
